import { deepEqual, type ParsedLocation } from '@tanstack/react-router'

/**
 * Параметры адреса, при смене которых страница остаётся той же: открытая бронь (модалка над любой
 * страницей) и переписка «Чатов». Остальные, включая выборы Студии, идут как смена страницы.
 */
const SELECTION = new Set(['booking', 'conversation'])

/** Переход открыл, закрыл или сменил только выбранный объект — страница осталась той же. */
export function isSelectionChange(from: ParsedLocation | undefined, to: ParsedLocation): boolean {
  if (!from || from.pathname !== to.pathname) return false
  const before = from.search as Record<string, unknown>
  const after = to.search as Record<string, unknown>
  let selected = false
  for (const key of new Set([...Object.keys(before), ...Object.keys(after)])) {
    if (deepEqual(before[key], after[key])) continue
    if (!SELECTION.has(key)) return false
    selected = true
  }
  return selected
}
